// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nu-0";